<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bag`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34 6h4v5.717a20.078 20.078 0 00-4-3.041V6zm8 11h-.135A19.916 19.916 0 0144 26v18a2 2 0 01-2 2H6a2 2 0 01-2-2V26c0-3.237.77-6.295 2.135-9H6V4.5A2.5 2.5 0 018.5 2h7A2.5 2.5 0 0118 4.5v2.416A19.992 19.992 0 0124 6c2.09 0 4.106.32 6 .916V4.5A2.5 2.5 0 0132.5 2h7A2.5 2.5 0 0142 4.5V17zM14 8.676V6h-4v5.717a20.078 20.078 0 014-3.041zM8 30v-4c0-8.837 7.163-16 16-16s16 7.163 16 16v4H8zm0 12v-8h32v8H8zm11-27a1 1 0 00-1 1v2a1 1 0 001 1h10a1 1 0 001-1v-2a1 1 0 00-1-1H19z"/></svg>
</template>
<script>

export default {
  name: 'IconBag',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
